// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  EXTINGUISHER_CHARGE_STATUSES
} from './../shared';

/**
 * `ExtinguisherChargeComponent` implements a view to show the charges status and ht status of a extinguisher.
 */
@Component({
  selector: 'she-extinguisher-charges',
  template: `<span class="she-charges she-charges-{{typeStatus}}">{{getStatus()}}</span>`
})
export class ExtinguisherChargesComponent {
  /**
   * Charges of current extinguisher.
   */
  @Input() typeStatus: number;

  /**
   * Creates a new `ExtinguisherChargesComponent` instance.
   */
  constructor() {}

  /**
   * Returns the status charge of current extinguisher.
   * @return extinguisher status charge
   */
  public getStatus(): string {
    return EXTINGUISHER_CHARGE_STATUSES[this.typeStatus];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/+extinguishers/extinguisher-charges.component.ts